module.exports = __webpack_public_path__ + "static/media/baseline-home.8e79f6ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/menu/baseline-home.svg
// module id = 52
// module chunks = 0